import { t } from 'i18next';
import { METRIC_INFO, METRIC_TYPES, TEMPERATURE_UNITS } from 'vio-constants';
import { convertCelsiusToFahrenheit, convertWattToKilowatt } from 'vio-libs';
export function calculateAllMetrics(allSiteMetrics) {
    const calculatedAllMetrics = {};
    const sites = Object.keys(allSiteMetrics);
    for (let i = 0; i < sites.length; i += 1) {
        const site = sites[i];
        const siteMetrics = allSiteMetrics[site];
        calculatedAllMetrics[site] = siteMetrics && siteMetrics.length > 0 ? calculateMetrics(siteMetrics) : [];
    }
    return calculatedAllMetrics;
}
export function calculateMetrics(metrics) {
    const { CELSIUS, FAHRENHEIT } = TEMPERATURE_UNITS;
    const decimalCount = 2;
    const calculatedMetrics = [];
    for (let i = 0; i < metrics.length; i += 1) {
        const { device_info, reading_type, unit_symbol, value } = metrics[i];
        const readingType = String(reading_type);
        const fixedValue = Number(value).toFixed(decimalCount);
        if (isAirflow(readingType, device_info)) {
            const calculatedMetric = {
                name: `${t('SITE', {
                    ns: 'Common'
                })} ${t('AIRFLOW', {
                    ns: 'Common'
                })}`,
                value: `${fixedValue} ${unit_symbol}`
            };
            calculatedMetrics.push(calculatedMetric);
        }
        if (isHumidity(readingType) || isPressure(readingType)) {
            const calculatedMetric = {
                name: `${t('SITE', {
                    ns: 'Common'
                })} ${isHumidity(readingType) ? t('HUMIDITY', {
                    ns: 'Common'
                }) : t('PRESSURE', {
                    ns: 'Common'
                })}`,
                value: `${fixedValue} ${unit_symbol}`
            };
            calculatedMetrics.push(calculatedMetric);
        }
        if (isPower(readingType)) {
            const calculatedMetric = {
                name: `${t('SITE', {
                    ns: 'Common'
                })} ${t('POWER', {
                    ns: 'Common'
                })}`,
                value: Number(fixedValue) < 1000 ? `${fixedValue} ${unit_symbol}` : `${convertWattToKilowatt(Number(fixedValue)).toFixed(decimalCount)} kW`
            };
            calculatedMetrics.push(calculatedMetric);
        }
        if (isPercentage(readingType)) {
            const calculatedMetric = {
                name: `${t('SITE', {
                    ns: 'Common'
                })} ${t('HUMIDITY', {
                    ns: 'Common'
                })}`,
                value: `${fixedValue} ${unit_symbol}`
            };
            calculatedMetrics.push(calculatedMetric);
        }
        if (isTemperature(readingType) && unit_symbol && (device_info === METRIC_INFO.AMBIENT_TEMPERATURE || device_info === METRIC_INFO.SYSTEM_TEMPERATURE || device_info === METRIC_INFO.NETWORK_TEMPERATURE)) {
            const fahrenheitValue = String(unit_symbol).toUpperCase() === CELSIUS ? convertCelsiusToFahrenheit(Number(value)).toFixed(decimalCount) : fixedValue;
            const calculatedMetric = {
                name: `${t('SITE', {
                    ns: 'Common'
                })} ${t('TEMPERATURE', {
                    ns: 'Common'
                })}`,
                value: `${fahrenheitValue} ${FAHRENHEIT}`
            };
            calculatedMetrics.push(calculatedMetric);
        }
    }
    return calculatedMetrics;
}
export function calculateRackMetrics(metrics) {
    const { CELSIUS, FAHRENHEIT } = TEMPERATURE_UNITS;
    const { FRONT, REAR } = METRIC_INFO;
    const decimalCount = 2;
    const calculatedRackMetrics = [];
    for (let i = 0; i < metrics.length; i += 1) {
        const { device_info, reading_type, unit_symbol, value } = metrics[i];
        const readingType = String(reading_type);
        const deviceInfo = String(device_info);
        const fixedValue = Number(value).toFixed(decimalCount);
        if (isPressure(readingType)) {
            const calculatedMetric = {
                name: `${t('RACK_PRESSURE')}`,
                value: `${fixedValue} ${unit_symbol}`
            };
            calculatedRackMetrics.push(calculatedMetric);
        }
        if (isTemperature(readingType) && unit_symbol) {
            const fahrenheitValue = String(unit_symbol).toUpperCase() === CELSIUS ? convertCelsiusToFahrenheit(Number(value)).toFixed(decimalCount) : fixedValue;
            const calculatedRackMetric = {
                name: '',
                value: `${fahrenheitValue} ${FAHRENHEIT}`
            };
            if (deviceInfo.includes('rack')) {
                calculatedRackMetric.name = t('RACK_TEMPERATURE', {
                    ns: 'Common'
                });
            }
            else if (deviceInfo === FRONT) {
                calculatedRackMetric.name = t('INLET_TEMPERATURE', {
                    ns: 'Common'
                });
            }
            else if (deviceInfo === REAR) {
                calculatedRackMetric.name = t('EXHAUST_TEMPERATURE', {
                    ns: 'Common'
                });
            }
            else {
                continue;
            }
            calculatedRackMetrics.push(calculatedRackMetric);
        }
    }
    return calculatedRackMetrics;
}
export function isAirflow(readingType, deviceInfo) {
    const deviceInformation = String(deviceInfo).toLowerCase();
    return !!(readingType === METRIC_TYPES.SPEED && deviceInformation.includes('airflow'));
}
export function isHumidity(readingType) {
    return readingType === METRIC_TYPES.HUMIDITY;
}
export function isPercentage(readingType) {
    return readingType === METRIC_TYPES.PERCENTAGE;
}
export function isPower(readingType) {
    return readingType === METRIC_TYPES.POWER;
}
export function isPressure(readingType) {
    return readingType === METRIC_TYPES.PRESSURE;
}
export function isTemperature(readingType) {
    return readingType === METRIC_TYPES.TEMPERATURE;
}
